import { Flag } from "@phosphor-icons/react";
import { fmtTime, sourceLabel } from "./threadUtils";

/* System-style milestone row (status change, assignment, arrival…) rendered inline in the chat. */
export function MilestoneChip({ item, testPrefix = "note" }) {
  const src = sourceLabel(item.source);
  return (
    <div className="flex items-center gap-3 py-0.5" data-testid={`${testPrefix}-milestone-${item.id}`}>
      <span className="h-px flex-1 bg-border/70" />
      <span className="inline-flex items-center gap-1.5 rounded-full border border-border bg-background px-2.5 py-1 text-[10px] text-muted-foreground max-w-[85%]">
        <Flag size={10} weight="fill" className="text-primary shrink-0" />
        <span className="truncate">{item.text}</span>
        {src && <span className="shrink-0 rounded bg-muted px-1 py-0.5 text-[9px] font-medium">{src}</span>}
        <span className="shrink-0 opacity-70">· {fmtTime(item.created_at)}</span>
      </span>
      <span className="h-px flex-1 bg-border/70" />
    </div>
  );
}
